<script setup lang="ts">
import type { GatIconProps } from '../gat-icon'
import { cn } from '../../lib/utils'
import type { BaseActionDropdownItem } from '@gat-ship/types'
import { computed } from 'vue'
import type { IconValues } from '@gat-ship/icons'
import type { GatLinkType } from './gat-link.vue'

const props = defineProps<{
  disabled?: boolean
  dataTestid?: string
  class?: string
  icon?: IconValues
  iconPosition?: 'left' | 'right'
  iconProps?: Partial<GatIconProps>
  text?: string
  dropdownItems?: (BaseActionDropdownItem | undefined)[]
  type?: GatLinkType
  href?: string
}>()

const _dropdownItems = computed(() => {
  const { dropdownItems } = props
  return dropdownItems?.filter((item) => item !== undefined) ?? []
})
</script>
<template>
  <component :is="type === 'link' ? 'a' : 'div'" :href="type === 'link' ? href : undefined"
    :data-disabled="props.disabled" :data-testid="props.dataTestid" :class="cn(
      'data-[disabled=true]:text-soft data-[disabled=true]:hover:text-link flex items-center gap-1',
      {
        'hover:text-link hover:decoration-link hover:cursor-pointer hover:underline':
          _dropdownItems.length > 0
      },
      props.class
    )
      ">
    <slot v-bind="{ icon: icon, text: text }">
      <span v-if="icon && iconPosition === 'left'" class="flex items-center justify-center">
        <GatIcon :icon="icon" v-bind="iconProps" :class="cn('size-3', iconProps?.class)" />
      </span>
      <span class="truncate">{{ text }}</span>
      <span v-if="icon && iconPosition === 'right'" class="flex items-center justify-center">
        <GatIcon :icon="icon" v-bind="iconProps" :class="cn('size-3', iconProps?.class)" />
      </span>
    </slot>
  </component>
</template>
